import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Authenticator from '../../components/cognito/Authenticator';
import { AppState } from '../../types/store';
import {
    addCandidate,
    createVacancy,
    deleteCandidate,
    deleteVacancy,
    fetchVacancies,
    inviteCandidate,
    shareWithHiringManager,
    updateCandidate,
    updateVacancy,
} from './actions';
import { addVacancyLink } from './actions/add-vacancy-link-action';
import Vacancies from './components/Vacancies';
import { getAllVacancies } from './reducer';
import { Candidate, Vacancy } from './types';

interface AdministratorStateProps {
    vacancies: Vacancy[];
}

interface AdministratorDispatchProps {
    onLoad: () => void;
    onCreateVacancy: () => void;
    onUpdateVacancy: (vacancy: Vacancy) => void;
    onDeleteVacancy: (vacancy: Vacancy) => void;
    onAddCandidate: (vacancyId: string, firstname: string, lastname: string, email: string) => void;
    onUpdateCandidate: (vacancyId: string, candidate: Candidate) => void;
    onDeleteCandidate: (vacancyId: string, candidate: Candidate) => void;
    onInviteCandidate: (vacancyId: string, candidate: Candidate) => void;
    onShareWithHiringManager: (vacancy: Vacancy) => void;
    onAddVacancyLink: (vacancy: Vacancy) => void;
}

interface AdministratorProps extends AdministratorStateProps, AdministratorDispatchProps {}

class Administrator extends React.Component<AdministratorProps, any> {
    constructor(props: AdministratorProps) {
        super(props);
        this.state = {};
        this.handleAuthStateChange = this.handleAuthStateChange.bind(this);
    }

    private handleAuthStateChange(state) {
        const signedIn = state === 'signedIn';
        if (signedIn) {
            this.props.onLoad();
        }
        this.setState({ signedIn });
    }

    public render() {
        return (
            <div>
                <Authenticator onStateChange={this.handleAuthStateChange} />
                {this.state.signedIn && (
                    <Vacancies
                        vacancies={this.props.vacancies}
                        onCreate={this.props.onCreateVacancy}
                        onUpdate={this.props.onUpdateVacancy}
                        onDelete={this.props.onDeleteVacancy}
                        onAddCandidate={this.props.onAddCandidate}
                        onUpdateCandidate={this.props.onUpdateCandidate}
                        onDeleteCandidate={this.props.onDeleteCandidate}
                        onInviteCandidate={this.props.onInviteCandidate}
                        onShareWithHiringManager={this.props.onShareWithHiringManager}
                        onAddVacancyLink={this.props.onAddVacancyLink}
                    />
                )}
            </div>
        );
    }
}

export const mapStateToProps = (state: AppState, ownProps): AdministratorStateProps => {
    return {
        vacancies: getAllVacancies(state),
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>): AdministratorDispatchProps => {
    return {
        onLoad: () => dispatch(fetchVacancies()),
        onCreateVacancy: () => dispatch(createVacancy()),
        onUpdateVacancy: (vacancy: Vacancy) => dispatch(updateVacancy(vacancy)),
        onDeleteVacancy: (vacancy: Vacancy) => dispatch(deleteVacancy(vacancy)),
        onAddCandidate: (vacancyId: string, firstname: string, lastname: string, email: string) =>
            dispatch(addCandidate(vacancyId, firstname, lastname, email)),
        onUpdateCandidate: (vacancyId: string, candidate: Candidate) => dispatch(updateCandidate(vacancyId, candidate)),
        onDeleteCandidate: (vacancyId: string, candidate: Candidate) => dispatch(deleteCandidate(vacancyId, candidate)),
        onInviteCandidate: (vacancyId: string, candidate: Candidate) => dispatch(inviteCandidate(vacancyId, candidate)),
        onShareWithHiringManager: (vacancy: Vacancy) => dispatch(shareWithHiringManager(vacancy)),
        onAddVacancyLink: (vacancy: Vacancy) => dispatch(addVacancyLink(vacancy)),
    };
};
export default connect<AdministratorStateProps, AdministratorDispatchProps, void>(
    mapStateToProps,
    mapDispatchToProps
)(Administrator);



// WEBPACK FOOTER //
// ./src/scenes/administrator/index.tsx